// 法语
export const GUIDES = [
  { name: 'guide-overview', title: 'Aperçu des fonctions', groupIndex: 0 },
  { name: 'guide-account', title: 'À propos du compte', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'À propos du véhicule', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Comment configurer le tableau de bord', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Comment configurer le véhicule', groupIndex: 1 },
  { name: 'guide-findNavigation', title: `Comment naviguer pour trouver le véhicule`, groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Comment utiliser la navigation', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: `À propos de l'historique de conduite`, groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Comment effectuer une auto-inspection du véhicule', groupIndex: 3 },
  { name: 'guide-useSetting', title: `Comment définir les paramètres généraux de l'APP`, groupIndex: 3 },
  { name: 'guide-notice', title: 'Comment afficher et définir la notification des messages', groupIndex: 3 },
  { name: 'guide-about', title: `À propos de l'application`, groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'En attente',
  1: 'pas de réponse',
  2: 'répondu',
  3: 'en communication',
  4: 'contre-mesures',
  5: 'résolu',
};

export const FEEDBACK_TYPES = {
  1: 'Rétroaction',
  2: 'Répondre',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
